import { Component, EventEmitter, Input, OnInit,AfterViewInit, Output } from '@angular/core';
import { NbMenuBag, NbMenuItem, NbMenuService, NbSidebarService } from '@nebular/theme';
import { Menu,MenuService,RutaMenu } from './menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit,AfterViewInit
{  @Output()
  RutaEnviar: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  bo_recargarMenu:boolean = false;
  @Input()
  bo_mostrarColapso:boolean = true;
  @Input()
  itemsComollega : any; 
  DarclickAlPadre:boolean=false; 
  
  item : NbMenuItem[] =[];
  itemsIcono: NbMenuItem[] = [];
  MensajeEnviar:string='';
  constructor(private menuService:  MenuService,
    private nbMenuService: NbMenuService)
    
  {
      
  }

  ngAfterViewInit(): void {
    this.nbMenuService.getSelectedItem().subscribe()
    this.nbMenuService.onItemClick().subscribe(
      (x)=>{
        if(x){
          if(x.tag == 'Menu')
            this.obtenerItem(x); 
          else if(x.tag == 'MenuIcono')
            this.obtenerItemConIcon(x); 
        }
      }
    );

  }
  ngOnInit(): void {
    
    if(this.itemsComollega ){
      if(this.bo_recargarMenu){
        this.menuService.getMenus().subscribe(menus => {
          if (menus) {
            this.itemsComollega=menus;
            this.item = this.itemsComollega.map((x:Menu) => this.map(x));
            this.itemsIcono = this.itemsComollega.map((x:Menu) => this.mapICono(x)); 
          }
        });
      }else{
        this.item = this.itemsComollega.map((x:Menu) => this.map(x));
        this.itemsIcono = this.itemsComollega.map((x:Menu) => this.mapICono(x)); 
      }
    }else{
       this.menuService.getMenus().subscribe(menus => {
        if (menus) {
          this.itemsComollega=menus;
          this.item = this.itemsComollega.map((x:Menu) => this.map(x));
          this.itemsIcono = this.itemsComollega.map((x:Menu) => this.mapICono(x)); 
        }
      }); 
    }
  }

  ngOnDestroy() {
    if(this.itemsComollega){
      this.item = this.itemsComollega.map((x:Menu) => this.map(x));
      this.itemsIcono = this.itemsComollega.map((x:Menu) => this.mapICono(x)); 
    }
  }

  map(menu: Menu): NbMenuItem {
    const res = new NbMenuItem();
    res.title = menu.title;
    res.icon = menu.icon;
    res.data = menu.id;
    if (menu.children && menu.children.length)
      res.children = menu.children.map(x => this.map(x));
    else if (menu.link.startsWith('http')) {
      res.link = 'general';
      res.queryParams = { url: menu.link };
    }
    else{
      res.link = menu.link;
    } 
    return res;
  }

  mapICono(menu: Menu): NbMenuItem {
    let res = new NbMenuItem();
    res.title = "";
    res.icon = menu.icon;
    res.data = menu.id;
    
    return res;
  }


  obtenerItem(x:NbMenuBag):void{
    this.MensajeEnviar='';
      this.MensajeEnviar=this.MensajeEnviar+x.item.title;
    if(x.item.parent){
      let y=x.item.parent;
      while(y){
        this.MensajeEnviar=y.title+'/'+this.MensajeEnviar;
        if(y.parent){
          y=y.parent;
        }else{
          break;
        }
      }
    }
    this.RutaEnviar.emit(this.MensajeEnviar);
    //this.nbMenuService.collapseAll();
    //this.nbSidebarService.compact();
         

  }
  obtenerItemConIcon(x:NbMenuBag):void{
    this.MensajeEnviar='';
    let index=this.item.findIndex(searchIndex=>searchIndex.data==x.item.data);
    
    if(index>-1){
      this.MensajeEnviar=this.MensajeEnviar+this.item[index].title;
    }
    this.RutaEnviar.emit(this.MensajeEnviar);
  }
  ClickObtenerMenuPadreConIcono(){
    if(!this.bo_mostrarColapso){
      this.fnCollapse("sidebar"); 
    }
    this.DarclickAlPadre=true;
    this.nbMenuService.collapseAll();
   
  }

  ClickObtenerMenuPadre(){
    let IdNodoPadre=0;
    let IdNodoHijo=0;
    
 
    this.MensajeEnviar="";
    this.nbMenuService.onItemHover().subscribe(
      item=>{
        let index=this.item.findIndex(searchIndex=>searchIndex.data==item.item.data);
    
        if(index>-1){
          IdNodoPadre =index;
            IdNodoHijo =index;
            //vaciar lista 
            this.MensajeEnviar=item.item.title;   
        }else{
          if(item.item.parent){
            this.MensajeEnviar=item.item.title;
            let y=item.item.parent;
            while(y){
              this.MensajeEnviar=y.title+'/'+this.MensajeEnviar;
              if(y.parent){
                y=y.parent;
              }else{
                break;
              }
            }
          }
          IdNodoHijo=-1;
        }

        if(IdNodoPadre==IdNodoHijo){
          if(this.DarclickAlPadre){
            this.DarclickAlPadre=false;
            this.nbMenuService.collapseAll();
          }else{
            
            this.DarclickAlPadre=true;
          }
        }else{
          this.DarclickAlPadre=true;
        }
        this.RutaEnviar.emit(this.MensajeEnviar);
        this.MensajeEnviar='';
      }
    ).unsubscribe();
    if(this.bo_mostrarColapso){
      this.fnCollapse("sidebar"); 
      this.DarclickAlPadre=true;
    }
  } 

  fnCollapse(sidebar: any) {
    $('#sidebar').css("z-index", 'auto');
    if (sidebar == 'sidebar') {
      $('#sidebar').toggleClass('active');
      this.bo_mostrarColapso = ($('#sidebar').hasClass('active')) ? true : false;
      if (this.bo_mostrarColapso) {
        $('.przss-content-child-menu').css('display', 'none');
      }
    }
   
  }
}
